// extracted by mini-css-extract-plugin
export default {"wrapper":"ApproveActions_wrapper__nyfcU","rightSpace":"ApproveActions_rightSpace__aupJ2","btn":"ApproveActions_btn__m55gr","secondary":"ApproveActions_secondary__kcfm+"};